import { GoogleSpreadsheet as Spreadsheet } from 'google-spreadsheet';

const sortedOutingSheets = new WeakSet();

function outingDateValue(value) {
  if (typeof value !== 'string') return null;
  const match = value.trim().match(/^(?:(\d{4})-(\d{2})-(\d{2})|(\d{1,2})\/(\d{1,2})\/(\d{4}))(?:[T\s].*)?$/);
  if (!match) return null;
  const year = Number(match[1] || match[6]);
  const month = Number(match[2] || match[5]);
  const day = Number(match[3] || match[4]);
  const date = new Date(0);
  date.setUTCFullYear(year, month - 1, day);
  if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) {
    return null;
  }
  return date.getTime();
}

// Preserve the library API and mutable row objects used by save/delete flows.
export class GoogleSpreadsheet extends Spreadsheet {
  constructor(id) {
    if (!id) throw new Error('Please select an organisation before loading its data.');
    super(id);
    this.axios.defaults.timeout = 30000;
  }

  async loadInfo(...args) {
    const result = await super.loadInfo(...args);
    const sheet = this.sheetsByTitle['reports_page'];
    if (sheet && !sortedOutingSheets.has(sheet)) {
      const getRows = sheet.getRows;
      sheet.getRows = async function (...rowArgs) {
        const rows = await getRows.apply(this, rowArgs);
        return rows
          .map((row, index) => ({ row, index, date: outingDateValue(row.Date) }))
          .sort((a, b) => {
            if (a.date === null && b.date !== null) return 1;
            if (b.date === null && a.date !== null) return -1;
            return (a.date === null ? 0 : b.date - a.date) || a.index - b.index;
          })
          .map(({ row }) => row);
      };
      sortedOutingSheets.add(sheet);
    }
    return result;
  }

  async useServiceAccountAuth(...args) {
    let timer;
    try {
      await Promise.race([
        super.useServiceAccountAuth(...args),
        new Promise((_, reject) => {
          timer = setTimeout(() => {
            const error = new Error('Authentication timed out');
            error.code = 'ECONNABORTED';
            reject(error);
          }, 30000);
        }),
      ]);
    } finally {
      clearTimeout(timer);
    }
  }
}
